import { ResolutionLevel, Status } from '../../../types';
import type { AiIncidentDto } from '../api/types';
import type { AiIncident, AiIncidentId } from '../model/types';

export const mapAiIncident = (dto: AiIncidentDto): AiIncident => ({
  id: dto.id as AiIncidentId,
  title: dto.title,
  description: dto.description,
  source: dto.source,
  certainty: dto.certainty,
  isViewed: dto.isViewed,
  resolutionLevel: dto.resolutionLevel ?? ResolutionLevel.GREEN,
  status: dto.status ?? Status.IN_PROGRESS,
  event: dto.event,
  control: dto.control ?? null,
  location: dto.location ?? null,
  userFunction: dto.userFunction ?? null,
  responsible: dto.responsible ?? null,
  registerBy: dto.sender ?? null,
  createdAt: dto.createdAt ?? new Date(),
});
